/**
 * Resolves the display name of a company: the commercial name when present,
 * otherwise the legal name (raison sociale).
 *
 * Signature is intentionally primitive (not a rigid `ICompany`) because callers
 * reach the name through different shapes: TypeORM entity (`commercialName: string | null`),
 * front shape (`commercialName?: string`, i.e. `string | undefined`). Accepting
 * `null | undefined` lets the helper absorb both shapes — it is the single typed
 * conversion seam, so call sites pass their field as-is without coercion.
 * `legalName` is always present (non-null in DB), so the return value can never be empty.
 */
export function getCompanyDisplayName(commercialName, legalName) {
    return commercialName ?? legalName;
}
//# sourceMappingURL=getCompanyDisplayName.js.map